// OPC 点位曲线：曲线设置（横轴跨度 / 纵轴范围 / 纵轴单位 / 横轴刻度间隔）的默认值与纯函数。
// settings 结构是炉子加热工单记录 config 的契约（queryState.settings），已有字段名不得改：
//   { span: number|null, spanUnit: 'm'|'h'|'d', ymin: number|null, ymax: number|null, yunit: string, xinterval: number|null }
//   yunit：手动纵轴单位，留空 = 按勾选点位的单位自动显示
//   xinterval：横轴刻度间隔（小时，可小数），留空 / ≤ 0 = echarts 默认刻度

export const SPAN_UNIT_MS = {
    m: 60 * 1000,
    h: 60 * 60 * 1000,
    d: 24 * 60 * 60 * 1000
};

export function defaultCurveSettings() {
    return {span: 24, spanUnit: 'h', ymin: null, ymax: null, yunit: '', xinterval: null};
}

// 输入框里的值 → number|null（空串 / 非数字都算「未填」）
export function toNumberOrNull(value) {
    if (value === null || value === undefined || value === '') {
        return null;
    }
    const n = Number(value);
    return Number.isFinite(n) ? n : null;
}

// 横轴跨度（ms）；未填或 ≤ 0 返回 null（= 显示全范围）
export function spanMs(settings) {
    const span = toNumberOrNull(settings && settings.span);
    const unitMs = SPAN_UNIT_MS[settings && settings.spanUnit];
    if (span === null || span <= 0 || !unitMs) {
        return null;
    }
    return span * unitMs;
}

// 横轴刻度间隔（ms）；未填或 ≤ 0 返回 null（= 默认刻度）
export function xIntervalMs(settings) {
    const hours = toNumberOrNull(settings && settings.xinterval);
    return hours === null || hours <= 0 ? null : hours * SPAN_UNIT_MS.h;
}

// 纵轴 min/max 都填了且 min ≥ max：图表忽略这两个值（按自动范围画）并在卡片上提示
export function yRangeInvalid(settings) {
    const ymin = toNumberOrNull(settings && settings.ymin);
    const ymax = toNumberOrNull(settings && settings.ymax);
    return ymin !== null && ymax !== null && ymin >= ymax;
}

// 图表初始视窗：停在最新一段 [end - span, end]；跨度未填或不小于整个范围时显示全范围
export function initialWindow(range, settings) {
    const start = range[0].getTime();
    const end = range[1].getTime();
    const span = spanMs(settings);
    if (span === null || span >= end - start) {
        return [start, end];
    }
    return [end - span, end];
}

function pad2(n) {
    return n < 10 ? '0' + n : '' + n;
}

// Date → 后端 history 接口要的本地时间串 yyyy-MM-ddTHH:mm:ss（不带时区，后端按 spring.jackson.time-zone 解释）
export function toServerTime(date) {
    return date.getFullYear() + '-' + pad2(date.getMonth() + 1) + '-' + pad2(date.getDate())
        + 'T' + pad2(date.getHours()) + ':' + pad2(date.getMinutes()) + ':' + pad2(date.getSeconds());
}

// Date → queryState / <input type="datetime-local"> 用的 yyyy-MM-ddTHH:mm
export function toInputTime(date) {
    return toServerTime(date).slice(0, 16);
}

// Date → sith-mes 接口 JSON 时间 yyyy-MM-dd HH:mm:ss（spring.jackson.date-format，GMT+8）
export function toApiTime(date) {
    return toServerTime(date).replace('T', ' ');
}

// yyyy-MM-ddTHH:mm[:ss] 或 yyyy-MM-dd HH:mm[:ss]（后端 JSON 时间）→ Date（按浏览器本地时间）；不合法返回 null。不用 new Date(str)：各浏览器对无时区串的解释不一致
export function parseInputTime(text) {
    const m = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})(?::(\d{2}))?/.exec(text || '');
    if (!m) {
        return null;
    }
    const date = new Date(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], m[6] ? +m[6] : 0, 0);
    return isNaN(date.getTime()) ? null : date;
}
